import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { SignJWT, importJWK } from 'jose';
// services
import {  FunctService, CommonService } from "@services/index";

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})


export class AppNavigationBarComponent implements OnInit, OnDestroy {
  promotionCount: any;
  promotionList: any;
  token: any;
  routerName: any;
  isUserLoggedIn: any;
  deviceId: any;
  profile: any={};
  unreadCount = 0;
  hasMention = false;
  useChat: boolean = false;
  id: string = "";
  private pollHandle: any = null;
  private bootstrapCache: { widgetToken: string; unreadEndpoint: string; expiresAtMs: number } | null = null;
  private readonly unreadPollIntervalMs = 5000;

 
  private readonly audience = 'chat-api';
  private readonly unread_aud ='chat-widget';
  private readonly chatUrl = 'https://chat.aazzme.com';
  private readonly kid = 'prod-sso-key-202607';
  private readonly alg = 'RS256';

//  loading = false;
userAgent: any;
constructor(
  private _service: CommonService,
  private funct: FunctService,
  private toastr: ToastrService,
  private router: Router,
    private storage: LocalStorageService,
    private http: HttpClient,
    private ngZone: NgZone,)
    {
      this.deviceId=this.storage.retrieve('localDeviceId');
    }
ngOnInit(): void
  {
    this.isUserLoggedIn= this.storage.retrieve('isUserLoggedIn');
    this.routerName = this.router.url;
    this.promotionCount = this.storage.retrieve('localpromotionCount');
    if(this.storage.retrieve('agentModel')) {
      this.userAgent = JSON.parse(atob(this.storage.retrieve('agentModel')));     
    }
    this._service.getProfile().then((data: any) => {
     this.profile = data;
     this.id = data?.is_sys_admin ? data?.admin_id : data?.user_id
     console.log("id :",this.id);
     console.log("profile", this.profile);
     if (this.isUserLoggedIn) {
       this.startUnreadPolling();
     }
    });
    this._service.getChatPsettings().then((data: any) => {
      this.useChat = data?.data.isUsed;
      console.log('useChat:', this.useChat);
    });
    // this.getAllPromotions();
}

ngOnDestroy(): void {
    if (this.pollHandle != null) {
      clearInterval(this.pollHandle);
      this.pollHandle = null;
    }
}

async startUnreadPolling(): Promise<void> {
    if (this.pollHandle != null) return;
    await this.tickUnread();
    this.pollHandle = setInterval(() => { this.tickUnread(); }, this.unreadPollIntervalMs);
}

async tickUnread(): Promise<void> {
    try {
      await this.ensureBootstrap();
      if (!this.bootstrapCache) return;
      const res = await fetch(this.bootstrapCache.unreadEndpoint, {
        headers: { Authorization: `Bearer ${this.bootstrapCache.widgetToken}` }
      });
      if (!res.ok) {
        console.warn('[chat-unread] tick failed:', res.status, res.statusText);
        return;
      }
      const data = await res.json();
      this.ngZone.run(() => {
        this.unreadCount = data?.totalUnread ?? 0;
        this.hasMention = !!data?.hasMention;
      });
      console.log('[chat-unread] tick @', new Date().toLocaleTimeString(), data);
    } catch (err) {
      console.error('[chat-unread] tick error:', err);
    }
}

private async ensureBootstrap(): Promise<void> {
    const now = Date.now();
    if (this.bootstrapCache && now < this.bootstrapCache.expiresAtMs - 15000) return;
    const b = await this.getChatBootstrap();
    if (!b) return;
    this.bootstrapCache = {
      widgetToken: b.widgetToken,
      unreadEndpoint: b.unreadEndpoint,
      expiresAtMs: new Date(b.expiresAt).getTime()
    };
}

openPage(routeUrl:string) {   
   
    if(routeUrl =='/home'){  
      if(this.deviceId != null){       
        this.router.navigate([routeUrl,this.deviceId]); 
        return;
      } 
      else{
        this.router.navigate([routeUrl]); 
        return;
      }    
    }
    this.router.navigate([routeUrl]);    
} 

async postChatTicket(): Promise<void> {

    try {
      const privateKey = await importJWK(this.funct.PRIVATE_JWK, this.alg);
      const now = Math.floor(Date.now() / 1000);
      const jti = this.funct.randomUuid();
      const raw = this.profile?.chat_roles;
      const role: string[] = Array.isArray(raw) ? raw : (raw ? [raw] : []);
      let lang = this.storage.retrieve('localLanguage') || 'en';
      const ticket = await new SignJWT({
        displayName: this.profile?.displayname,
        avatarUrl: this.profile?.imageUrl,
        accountStatus: this.profile?.status?.toLowerCase(),
        locale: lang,
        roles: role,
        groupId: this.profile?.chat_group_id,
        adminGroupId: this.profile?.adminGroupId
      })
        .setProtectedHeader({ alg: this.alg, kid: this.kid })
        .setIssuer(this.funct.issuer)
        .setAudience(this.audience)
        .setSubject(this.id)
        .setJti(jti)
        .setIssuedAt(now)
        .setExpirationTime(now + 45)
        .sign(privateKey);

      const [headerB64, payloadB64, signatureB64] = ticket.split('.');
      console.group('[chat-button] POST /sso ticket');
      console.log('ticket:', ticket);
      console.log('header:', JSON.parse(this.funct.b64UrlDecode(headerB64)));
      console.log('payload:', JSON.parse(this.funct.b64UrlDecode(payloadB64)));
      console.log('signature (b64url):', signatureB64);
      console.log('target:', `${this.chatUrl}/sso`);
      console.groupEnd();

      this.http.post(`${this.chatUrl}/sso`, { ticket }).subscribe({
        next: (res: any) => {
          console.log('[chat-button] POST /sso response:', res);
        },
        error: (err: any) => {
          const message =
            (err && err.error && err.error.error) ||
            (err && err.message) ||
            'POST to chat.aazzme.com/sso failed';
          this.toastr.error(message, 'Chat login failed');
          console.error('[chat-button] POST /sso error:', err);
        }
      });
    } catch (err) {
      const message =
        (err && (err as { message?: string }).message) ||
        'Failed to sign SSO ticket';
      this.toastr.error(message, 'Chat login failed');
      console.error('[chat-err] postChatTicket failed:', err);
    }
  }

async getChatTicket(): Promise<void> {

    try {
      const privateKey = await importJWK(this.funct.PRIVATE_JWK, this.alg);
      const now = Math.floor(Date.now() / 1000);
      const jti = this.funct.randomUuid();
      const raw = this.profile?.chat_roles;
      const role: string[] = Array.isArray(raw) ? raw : (raw ? [raw] : []);
      let lang = this.storage.retrieve('localLanguage') || 'en';
      const ticket = await new SignJWT({
        displayName: this.profile?.displayname,
        avatarUrl: this.profile?.imageUrl,
        accountStatus: this.profile?.status?.toLowerCase(),
        locale: lang,
        roles: role
      })
        .setProtectedHeader({ alg: this.alg, kid: this.kid })
        .setIssuer(this.funct.issuer)
        .setAudience(this.audience)
        .setSubject(this.id)
        .setJti(jti)
        .setIssuedAt(now)
        .setExpirationTime(now + 45)
        .sign(privateKey);

      const targetUrl = `${this.chatUrl}/sso?ticket=${encodeURIComponent(ticket)}`;
      const [headerB64, payloadB64, signatureB64] = ticket.split('.');
      // console.group('[chat-button] GET /sso ticket');
      // console.log('ticket:', ticket);
      // console.log('header:', JSON.parse(this.funct.b64UrlDecode(headerB64)));
      // console.log('payload:', JSON.parse(this.funct.b64UrlDecode(payloadB64)));
      // console.log('signature (b64url):', signatureB64);
      // console.log('target:', targetUrl);
      // console.groupEnd();

      this.http.get(targetUrl, { responseType: 'text', observe: 'response' }).subscribe({
        next: (res) => {
          console.group('[chat-button] GET /sso response');
          console.log('status:', res.status, res.statusText);
          console.log('headers.content-type:', res.headers.get('content-type'));
          console.log('body (first 500 chars):', (res.body || '').slice(0, 500));
          console.groupEnd();
        },
        error: (err: any) => {
          const message =
            (err && err.error && err.error.error) ||
            (err && err.message) ||
            'GET to chat.aazzme.com/sso failed';
          this.toastr.error(message, 'Chat login failed');
          console.log('[chat-button] GET /sso error:', err);
          
        }
      });
    } catch (err) {
      const message =
        (err && (err as { message?: string }).message) ||
        'Failed to sign SSO ticket';
      this.toastr.error(message, 'Chat login failed');
      console.error('[chat-err] getChatTicket failed:', err);
    }
  }

async getChatBootstrap(): Promise<any> {

    try {
      const privateKey = await importJWK(this.funct.PRIVATE_JWK, this.alg);
      const now = Math.floor(Date.now() / 1000);
      const expiresIn = 300;

      const widgetToken = await new SignJWT({
        accountStatus: this.profile?.status?.toLowerCase() || 'active'
      })
        .setProtectedHeader({ alg: this.alg, kid: this.kid })
        .setIssuer(this.funct.issuer)
        .setAudience(this.unread_aud)
        .setSubject(this.id)
        .setIssuedAt(now)
        .setExpirationTime(now + expiresIn)
        .sign(privateKey);

      const bootstrap = {
        widgetToken,
        unreadEndpoint: 'https://chatapi.aazzme.com/widget/unread',
        entryEndpoint: '/api/chat/entry',
        expiresAt: new Date((now + expiresIn) * 1000).toISOString()
      };

      const [headerB64, payloadB64, signatureB64] = widgetToken.split('.');
      console.group('[chat-button] GET /api/chat/bootstrap');
      console.log('widgetToken:', widgetToken);
      console.log('header:', JSON.parse(this.funct.b64UrlDecode(headerB64)));
      console.log('payload:', JSON.parse(this.funct.b64UrlDecode(payloadB64)));
      console.log('signature (b64url):', signatureB64);
      console.log('bootstrap:', bootstrap);
      console.groupEnd();

      return bootstrap;
    } catch (err) {
      const message =
        (err && (err as { message?: string }).message) ||
        'Failed to sign widget token';
      this.toastr.error(message, 'Chat bootstrap failed');
      console.error('[chat-err] getChatBootstrap failed:', err);
      throw err;
    }
  }

async openChat(): Promise<void> {

    const chatWindow = window.open('about:blank', '_blank');

    try {
      const privateKey = await importJWK(this.funct.PRIVATE_JWK, this.alg);
      const now = Math.floor(Date.now() / 1000);
      const jti = this.funct.randomUuid();
      const raw = this.profile?.chat_roles;
      const role: string[] = Array.isArray(raw) ? raw : (raw ? [raw] : []);
      let lang = this.storage.retrieve('localLanguage') || 'en';

      const ticket = await new SignJWT({
        displayName: this.profile?.displayname,
        avatarUrl: this.profile?.imageUrl,
        accountStatus: this.profile?.status?.toLowerCase(),
        locale: lang,
        roles: role,
        groupId:this.profile?.chat_group_id,
        adminGroupId :this.profile?.adminGroupId
      })
        .setProtectedHeader({ alg: this.alg, kid: this.kid })
        .setIssuer(this.funct.issuer)
        .setAudience(this.audience)
        .setSubject(this.id)
        .setJti(jti)
        .setIssuedAt(now)
        .setExpirationTime(now + 45)        
        .sign(privateKey);

      const redirectUrl = `${this.chatUrl}/sso?ticket=${encodeURIComponent(ticket)}`;
      console.log('[chat-button] RS256-signed ticket redirect:', redirectUrl);

      if (!chatWindow) {
        this.toastr.error(
          'Popup blocked. Please allow popups for this site.',
          'Chat login failed'
        );
        console.error('[chat-button] Popup blocked. Please allow popups for this site.');
        //this.loading = false;
        return;
      }
      chatWindow.opener = null;
      const [headerB64, payloadB64, signatureB64] = ticket.split('.');
      console.group('[chat-button] SSO ticket');
      console.log('ticket:', ticket);
      console.log('header:', JSON.parse(this.funct.b64UrlDecode(headerB64)));
      console.log('payload:', JSON.parse(this.funct.b64UrlDecode(payloadB64)));
      console.log('signature (b64url):', signatureB64);
      console.log('redirectUrl:', redirectUrl);
      console.groupEnd();
      chatWindow.location.replace(redirectUrl);
      //this.loading = false;
    } catch (err) {
      if (chatWindow) chatWindow.close();
      //this.loading = false;
      const message =
        (err && (err as { message?: string }).message) ||
        'Failed to sign SSO ticket';
      this.toastr.error(message, 'Chat login failed');
      console.error('[chat-err] Chat login failed:', err);
    }
  }

 
}
